export function match (value: string, option: string | string[] | { regex: string, flags?: string }): boolean {
  if (typeof option === 'string') {
    return value === option
  }
  if (typeof option === 'object' && Array.isArray(option)) {
    return option.includes(value)
  }
  const { regex, flags } = option
  const re = new RegExp(regex, flags)
  return re.test(value)
}
